import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import { Box, Button, IconButton, Typography } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import { useDropzone } from "react-dropzone";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { allergies, relations } from "../../utils/constants";
import { v4 as uuidv4 } from "uuid";

import "react-select-v1/dist/react-select.css";
import "react-virtualized/styles.css";
import "react-virtualized-select/styles.css";
import AddressAutoComplete from "./address-autocomplete";

export function PatientDetailsForm(props) {
  const ageCheck = (IDNumber) => {
    var tempDate = new Date(
      IDNumber.substring(0, 2),
      IDNumber.substring(2, 4) - 1,
      IDNumber.substring(4, 6)
    );

    var diff_ms = Date.now() - tempDate.getTime();
    var age_dt = new Date(diff_ms);
    var age = Math.abs(age_dt.getUTCFullYear() - 1970);
    return age;
  };

  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Session ID"
          variant="outlined"
          onChange={props.handleChange}
          id="SessionID"
          disabled={true}
          value={props.form.SessionID}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      {Boolean(props.branches.length) && (
        <Grid
          item
          xs={4}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <TextField
            select
            label="Branch"
            name="Branch"
            id="Branch"
            onChange={props.handleChange}
            value={props.form.Branch}
            SelectProps={{
              native: true,
            }}
            sx={{ maxWidth: "240px", minWidth: "240px" }}
            fullWidth
          >
            {props.branches.map((branch) => {
              return (
                <option value={branch.Prefix} key={uuidv4()}>
                  {branch.Name}
                </option>
              );
            })}
          </TextField>
        </Grid>
      )}

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          select
          label="Title"
          name="Title"
          id="Title"
          onChange={props.handleChange}
          value={props.form.Title}
          SelectProps={{
            native: true,
          }}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
          fullWidth
        >
          <option value="ADV">ADV</option>
          <option value="MRS">MRS</option>
          <option value="PROF">PROF</option>
          <option value="SIS">SIS</option>
          <option value="MAST">MAST</option>
          <option value="MS">MS</option>
          <option value="PRIS">PRIS</option>
          <option value="MNR">MNR</option>
          <option value="MEV">MEV</option>
          <option value="MEJ">MEJ</option>
          <option value="MISS">MISS</option>
          <option value="DS">DS</option>
          <option value="SEUN">SEUN</option>
          <option value="INSP">INSP</option>
          <option value="PAST">PAST</option>
          <option value="KOL">KOL</option>
          <option value="DR">DR</option>
          <option value="SUPT">SUPT</option>
          <option value="DM">DM</option>
          <option value="REV">REV</option>
          <option value="KAPT">KAPT</option>
          <option value="SERS">SERS</option>
          <option value="ME">ME</option>
          <option value="PHYS">PHYS</option>
          <option value="MR">MR</option>
          <option value="CAPT">CAPT</option>
          <option value="SEG">SEG</option>
        </TextField>
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="First Name"
          variant="outlined"
          onChange={props.handleChange}
          id="FirstName"
          value={props.form.FirstName}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Last Name"
          variant="outlined"
          onChange={props.handleChange}
          id="LastName"
          value={props.form.LastName}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Initials"
          variant="outlined"
          onChange={props.handleChange}
          id="Initials"
          value={props.form.Initials}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          select
          label="Sex"
          name="Sex"
          id="Sex"
          onChange={props.handleChange}
          value={props.form.Sex}
          SelectProps={{
            native: true,
          }}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
          fullWidth
        >
          <option value={"Male"}>Male</option>
          <option value={"Female"}>Female</option>
        </TextField>
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="ID /Passport Number"
          variant="outlined"
          onChange={props.handleChange}
          id="IDNumber"
          value={props.form.IDNumber}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Age"
          disabled={true}
          variant="outlined"
          id="Age"
          value={ageCheck(props.form.IDNumber)}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Phone Number"
          variant="outlined"
          onChange={props.handleChange}
          id="PhoneNumber"
          value={props.form.PhoneNumber}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Email Address"
          variant="outlined"
          onChange={props.handleChange}
          id="Email"
          value={props.form.Email}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        

        <TextField
          id="DOB"
          label="DOB"
          type="datetime-local"
          defaultValue={props.form.DateOfBirthRaw}
          fullWidth
          onChange={(newValue) => {
            props.setDOB({
              DateOfBirthRaw: newValue.target.value,
              DateOfBirthTimestamp: new Date(newValue.target.value).getTime(),
            });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          select
          label="Allergies"
          name="Allergies"
          id="Allergies"
          onChange={props.handleChange}
          value={props.form.Allergies}
          SelectProps={{
            native: true,
          }}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
          fullWidth
        >
          {allergies.map((allergy) => {
            return (
              <option value={allergy} key={uuidv4()}>
                {allergy}
              </option>
            );
          })}
        </TextField>
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ height: 56, position: "relative" }}>
          <AddressAutoComplete
            handleChange={props.handleChange}
            value={props.form.PhysicalAddress}
            id="PhysicalAddress"
            label="Physical Address"
          />
        </Box>
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ height: 56, position: "relative" }}>
          <AddressAutoComplete
            handleChange={props.handleChange}
            value={props.form.PostalAddress}
            id="PostalAddress"
            label="Postal Address"
          />
        </Box>
      </Grid>
    </Grid>
  );
}

export function EmploymentDetailsForm(props) {
  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Contact Person"
          variant="outlined"
          onChange={props.handleChange}
          id="ContactPerson"
          value={props.form.ContactPerson}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Employer Contact Number"
          variant="outlined"
          onChange={props.handleChange}
          id="EmployerContactNumber"
          value={props.form.EmployerContactNumber}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Occupation"
          variant="outlined"
          onChange={props.handleChange}
          id="Occupation"
          value={props.form.Occupation}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Company Number"
          variant="outlined"
          onChange={props.handleChange}
          id="CompanyNumber"
          value={props.form.CompanyNumber}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Company Name"
          variant="outlined"
          onChange={props.handleChange}
          id="CompanyName"
          value={props.form.CompanyName}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ height: 56, position: "relative" }}>
          <AddressAutoComplete
            handleChange={props.handleChange}
            value={props.form.EmployerPhysicalAddress}
            id="EmployerPhysicalAddress"
            label="Physical Address"
          />
        </Box>
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
      
        <TextField
          id="IncidentDate"
          label="IncidentDate"
          type="datetime-local"
          defaultValue={props.form.IncidentDate}
          onChange={props.handleChangeDate}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="COIDRef"
          variant="outlined"
          onChange={props.handleChange}
          id="COIDRef"
          value={props.form.COIDRef}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="COIDEmployerName"
          variant="outlined"
          onChange={props.handleChange}
          id="COIDEmployerName"
          value={props.form.COIDEmployerName}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="COIDEmployerRegNumber"
          variant="outlined"
          onChange={props.handleChange}
          id="COIDEmployerRegNumber"
          value={props.form.COIDEmployerRegNumber}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="COIDEmployeeNumber"
          variant="outlined"
          onChange={props.handleChange}
          id="COIDEmployeeNumber"
          value={props.form.COIDEmployeeNumber}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>
    </Grid>
  );
}

export function MedicalAidDetailsForm(props) {
  const {disabled} = props
  let dependentCodesArray = [];
  for (let i = 0; i < 21; i++)
    dependentCodesArray = [...dependentCodesArray, i ];
    
    
  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          select
          label="Relation to Member"
          id="MedicalAidMemberRelationToPatient"
          helperText="Relation of the member to the patient"
          onChange={props.handleChange}
          value={props.form.MedicalAidMemberRelationToPatient}
          disabled={disabled}
          SelectProps={{
            native: true,
          }}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
          fullWidth
        >
          {relations.map((relation) => {
            return (
              <option value={relation} key={uuidv4()}>
                {relation}
              </option>
            );
          })}
        </TextField>
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Title"
          helperText="Member's Title"
          variant="outlined"
          onChange={props.handleChange}
          id="MedicalAidMemberTitle"
          value={props.form.MedicalAidMemberTitle}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="First Name"
          helperText="Member's first name"
          variant="outlined"
          onChange={props.handleChange}
          id="MedicalAidMemberFirstName"
          value={props.form.MedicalAidMemberFirstName}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Last Name"
          helperText="Member's last name"
          variant="outlined"
          onChange={props.handleChange}
          id="MedicalAidMemberLastName"
          value={props.form.MedicalAidMemberLastName}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Initials"
          helperText="Member's Initials"
          variant="outlined"
          onChange={props.handleChange}
          id="MedicalAidMemberInitials"
          value={props.form.MedicalAidMemberInitials}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="ID / 
                         Passport Number"
          helperText="Member's ID / Passport Number"
          variant="outlined"
          onChange={props.handleChange}
          id="MedicalAidMemberIDNumber"
          value={props.form.MedicalAidMemberIDNumber}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}

        />
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Phone Number"
          helperText="Member's contact number"
          variant="outlined"
          onChange={props.handleChange}
          id="MedicalAidMemberPhoneNumber"
          value={props.form.MedicalAidMemberPhoneNumber}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          select
          label="Medical Aid Name"
          id="MedicalAidName"
          onChange={props.handleChange}
          value={props.form.MedicalAidName}
          
          SelectProps={{
            native: true,
          }}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
          fullWidth
        >
          {props.medicalAidNames.map((mdn) => (
            <option key={uuidv4()} value={mdn.value} >
              {mdn.label}
            </option>
          ))}
        </TextField>
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Medical Aid 
                         Number"
          variant="outlined"
          onChange={props.handleChange}
          id="MedicalAidNumber"
          value={props.form.MedicalAidNumber}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Medical Aid 
                         Plan"
          variant="outlined"
          onChange={props.handleChange}
          id="MedicalAidPlan"
          value={props.form.MedicalAidPlan}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          select
          label="Dependent Code"
          id="DependentCode"
          onChange={props.handleChange}
          value={props.form.DependentCode}
          SelectProps={{
            native: true,
          }}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
          fullWidth
        >
          {dependentCodesArray.map((_, index) => (
            <option key={uuidv4()} value={index}>
              {" "}
              {index}{" "}
            </option>
          ))}
        </TextField>
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="VAT Number"
          variant="outlined"
          onChange={props.handleChange}
          id="MedicalAidVatNumber"
          value={props.form.MedicalAidVatNumber}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ height: 56, position: "relative" }}>
          <AddressAutoComplete
            handleChange={props.handleChange}
            value={props.form.MedicalAidMemberPostalAddress}
            disabled={disabled}
            id="MedicalAidMemberPostalAddress"
            label="Member's postal address"
          />
        </Box>
      </Grid>
      
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Member Employer Name"
          variant="outlined"
          onChange={props.handleChange}
          id="MedicalAidMemberMemberEmployerName"
          value={props.form.MedicalAidMemberMemberEmployerName}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Member Work Department"
          variant="outlined"
          onChange={props.handleChange}
          id="MedicalAidMemberMemberWorkDepartment"
          value={props.form.MedicalAidMemberMemberWorkDepartment}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Member Occupation"
          variant="outlined"
          onChange={props.handleChange}
          id="MedicalAidMemberMemberOccupation"
          value={props.form.MedicalAidMemberMemberOccupation}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Member Work Phone"
          variant="outlined"
          onChange={props.handleChange}
          id="MedicalAidMemberMemberWorkPhone"
          value={props.form.MedicalAidMemberMemberWorkPhone}
          disabled={disabled}
          sx={{ maxWidth: "240px", minWidth: "240px" }}
        />
      </Grid>
      <Grid
        item
        xs={4}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ height: 56, position: "relative" }}>
          <AddressAutoComplete
            handleChange={props.handleChange}
            value={props.form.MedicalAidMemberMemberWorkAddress}
            disabled={disabled}
            id="MedicalAidMemberMemberWorkAddress"
            label="Member Work Address"
          />
        </Box>
      </Grid>
      
    </Grid>
  );
}

export function DocumentsForm(props) {
  const other_docs_dummy_arr = [
    "ONE",
    "TWO",
    "THREE",
    "FOUR",
    "FIVE",
    "SIX",
    "SEVEN",
    "EIGHT",
    "NINE",
  ];


  return (
    <Grid container spacing={2} sx={{ pt: 2 }}>
      <Grid item xs={4}>
        <DocumentUploadChip
          docType={"ID_DOC"}
          doc={props.form["ID_DOC"]}
          label={"Upload Patient ID"}
          handleChange={props.handleChange}
        />
      </Grid>
      <Grid item xs={4}>
        <DocumentUploadChip
          docType={"MEDICAL_AID_DOC"}
          doc={props.form["MEDICAL_AID_DOC"]}
          label={"Upload Medical aid card"}
          handleChange={props.handleChange}
        />
      </Grid>
      <Grid item xs={4}>
        <DocumentUploadChip
          docType={"REF_NOTE_DOC"}
          doc={props.form["MEDICAL_AID_DOC"]}
          label={"Upload Ref note"}
          handleChange={props.handleChange}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="4">Upload Other</Typography>
      </Grid>

      {other_docs_dummy_arr.map((item, i) => {
        return (
          <Grid item xs={4} key={uuidv4()}>
            <DocumentUploadChip
              docType={`OTHER_DOC_${item}`}
              doc={props.form[`OTHER_DOC_${item}`]}
              label={`Other Doc ${item}`}
              handleChange={props.handleChange}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}

const DocumentUploadChip = (props) => {
  const [files, setFiles] = useState([]);
  const [currentFiles, setCurrentFiles] = useState(props.doc);


  console.log(`docType ${props.docType} doc ${props.doc}`)
  const [openDocumentPreviewModal, setOpenDocumentPreviewModal] =
    useState(false);

  const handleOpenDocumentPreviewModal = () =>
    setOpenDocumentPreviewModal(true);

  const handleCloseDocumentPreviewModal = () =>
    setOpenDocumentPreviewModal(false);

  const DOCUMENT_AVALAIBLE = Boolean(files[0]);

  console.log("DOCUMENT_AVALAIBLE",DOCUMENT_AVALAIBLE)
  console.log("files",files[0])
  
  function imageToBase64() {
    const file = files[0];
    const reader = new FileReader();

    reader.onload = () => {
      let base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      const payload = {
        target: {
          id: props.docType,
          value: `data:image/jpeg;base64,${base64String}`,
        },
      };


      props.handleChange(payload);
      
    };
    reader.readAsDataURL(file);
  }

  useEffect(() => {
    if (files[0]) imageToBase64();
    return () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    };
  }, [files]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/jpeg, image/png, image/webp",
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
      setCurrentFiles("")
    },
  });

  return (
    <>
      <Box>
        <Box
          sx={{
            maxWidth: "240px",
            minWidth: "240px",
            background: "#555",
            border: "1px #888 solid",
            display: "flex",
            mb: 1,
          }}
        >
          <Box
            sx={{
              height: "50px",
              background: "#222",
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRight: "1px #000 solid",
              cursor: "default",
              color: "#fff",
            }}
          >
            {props.label}
          </Box>

          <Box
            {...getRootProps({
              className: "dropzone",
            })}
            style={{
              height: "50px",
              width: "50px",
              backgroundColor: "#222",
              backgroundImage: files[0]
                ? `url(${files[0].preview})`
                : currentFiles
                ? currentFiles
                : "unset",
              backgroundSize: "cover",
              cursor: "pointer",
              position: "relative",
            }}
          >
            <Button
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 0,
                height: "100%",
                width: "100%",
                minWidth: "unset",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 10,
                background: "rgba(0,0,0,.6)",
              }}
            >
              <UploadIcon sx={{ color: "#fff" }} />
            </Button>
            <input
              style={{ height: "100%", width: "100%" }}
              {...getInputProps()}
            />
          </Box>
        </Box>

        {DOCUMENT_AVALAIBLE || currentFiles && (
          <Typography
            variant="p"
            sx={{ cursor: "pointer" }}
            onClick={handleOpenDocumentPreviewModal}
          >
            View Document
          </Typography>
        )}
      </Box>

      {openDocumentPreviewModal && (
        <DocumentPreviewModal
          handleClose={handleCloseDocumentPreviewModal}
          doc={files[0] ? files[0].preview : currentFiles ? currentFiles:""}
        />
      )}
    </>
  );
};

const style = {
  minWidth: 500,
  width: 350,
  maxWidth: "70vw",
  bgcolor: "background.paper",
  position: "relative",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const DocumentPreviewModal = (props) => {
  return (
    <Modal
      open={true}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box sx={style}>
        <IconButton
          onClick={props.handleClose}
          sx={{
            position: "absolute",
            background: "#333",
            right: "-45px",
            top: "45px",
          }}
        >
          <CloseIcon sx={{ color: "#fff" }} />
        </IconButton>
        <img
          style={{
            height: "100%",
            width: "100%",
            objectFit: "contain",
            objectPosition: "center",
          }}
          src={props.doc}
          alt="scanned doc"
        />
      </Box>
    </Modal>
  );
};
